import React, { Component } from 'react';
import ReactDom from 'react-dom';

export default class FileUpload extends Component {
    handleFile = ( e ) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        if( !file ) return;
        const fileType = file.type.split('/')[1].toLowerCase()
        const validTypes = [ 'jpg', 'jpeg', 'svg+xml', 'svg', 'png', 'gif', 'bpm', 'tif' ];

        if( validTypes.every( type => fileType !== type ) ){
            alert('you must upload an image file')
            return 
        }

        reader.onload = ( img ) => {
            ReactDom.findDOMNode( this.refs.in ).value = '';
            this.props.handleFileChange( img.target.result );
        }
        reader.readAsDataURL( file );
    }

    render () {
        return (
            <input ref='in' type='file' accept='image/*' onChange={ this.handleFile } />
        )
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/picture/FileUpload.js